/**
 * Kismet Palette System
 * Manages color palette rotation via cookies
 * Palettes: submarine, salad, electric, skittles, lego
 */
(function() {
  'use strict';

  var COOKIE_NAME = 'kismet_theme';
  var COOKIE_EXPIRY = 3600; // 1 hour in seconds
  var PALETTES = ['submarine', 'salad', 'electric', 'skittles', 'lego'];

  /**
   * Get a cookie value by name
   */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  /**
   * Set a cookie with expiration
   */
  function setCookie(name, value, seconds) {
    var date = new Date();
    date.setTime(date.getTime() + (seconds * 1000));
    var expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/;SameSite=Lax';
  }

  /**
   * Get a random palette from the available palettes
   */
  function getRandomPalette() {
    var randomIndex = Math.floor(Math.random() * PALETTES.length);
    return PALETTES[randomIndex];
  }

  /**
   * Check if palette rotation is enabled (via Shopify settings)
   */
  function isRotationEnabled() {
    // Check if theme settings disable rotation
    if (typeof window.Shopify !== 'undefined' &&
        window.Shopify.theme &&
        window.Shopify.theme.settings &&
        window.Shopify.theme.settings.palette_rotation_enabled === false) {
      return false;
    }
    return true;
  }

  /**
   * Get the default palette from settings
   */
  function getDefaultPalette() {
    if (typeof window.Shopify !== 'undefined' &&
        window.Shopify.theme &&
        window.Shopify.theme.settings &&
        window.Shopify.theme.settings.palette_default) {
      return window.Shopify.theme.settings.palette_default;
    }
    return 'skittles';
  }

  /**
   * Apply the palette theme to the document
   */
  function applyPalette(palette) {
    document.documentElement.setAttribute('data-theme', palette);
    document.body.setAttribute('data-theme', palette);
  }

  /**
   * Check if we're in Shopify's theme editor
   */
  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  /**
   * Main initialization function
   */
  function init() {
    // In design mode, don't touch cookies or randomize - let Liquid control the palette
    if (isDesignMode()) {
      return;
    }

    var currentPalette = getCookie(COOKIE_NAME);
    var isValidPalette = currentPalette && PALETTES.indexOf(currentPalette) !== -1;

    if (!isValidPalette) {
      // No valid cookie exists - determine palette
      if (isRotationEnabled()) {
        currentPalette = getRandomPalette();
      } else {
        currentPalette = getDefaultPalette();
      }
      setCookie(COOKIE_NAME, currentPalette, COOKIE_EXPIRY);
    }

    // Apply the palette (in case the inline script in <head> didn't run or had a different value)
    applyPalette(currentPalette);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose API for debugging/testing
  window.KismetPalette = {
    getPalettes: function() { return PALETTES.slice(); },
    getCurrentPalette: function() { return getCookie(COOKIE_NAME); },
    setPalette: function(palette) {
      if (PALETTES.indexOf(palette) !== -1) {
        setCookie(COOKIE_NAME, palette, COOKIE_EXPIRY);
        applyPalette(palette);
        return true;
      }
      return false;
    },
    rotatePalette: function() {
      var newPalette = getRandomPalette();
      setCookie(COOKIE_NAME, newPalette, COOKIE_EXPIRY);
      applyPalette(newPalette);
      return newPalette;
    },
    clearPalette: function() {
      document.cookie = COOKIE_NAME + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    }
  };
})();
